export default "__VITE_ASSET__CXAtskYH__"